"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselScrollContainerMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _focusMixin = require("../focusMixin");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _spaceMixin = require("../spaceMixin");
var enableSnapCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('enableSnap', function (_ref) {
  var enableSnap = _ref.enableSnap;
  return (0, _styledComponents.css)(["scroll-snap-type:", ";scroll-behavior:smooth;@media (prefers-reduced-motion:reduce){scroll-behavior:auto;}"], enableSnap ? 'x mandatory' : 'none');
});
var scrollOffsetCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('scrollOffset', function (props) {
  var scrollOffset = props.scrollOffset;
  return (0, _styledToken.default)({
    paddingTop: 'CarouselScrollContainer.scrollOffset.paddingTop',
    paddingBottom: 'CarouselScrollContainer.scrollOffset.paddingBottom',
    scrollPaddingY: 'CarouselScrollContainer.scrollOffset.scrollPaddingY'
  }, function (_ref2) {
    var _ref2$paddingTop = _ref2.paddingTop,
      paddingTop = _ref2$paddingTop === void 0 ? (0, _spaceMixin.spaceMixin)('xs')(props) : _ref2$paddingTop,
      _ref2$paddingBottom = _ref2.paddingBottom,
      paddingBottom = _ref2$paddingBottom === void 0 ? 18 : _ref2$paddingBottom,
      _ref2$scrollPaddingY = _ref2.scrollPaddingY,
      scrollPaddingY = _ref2$scrollPaddingY === void 0 ? 0 : _ref2$scrollPaddingY;
    return (0, _styledComponents.css)(["padding:", "px ", " ", "px;scroll-padding:", "px ", ";"], paddingTop, (0, _spaceMixin.spaceMixin)(scrollOffset), paddingBottom, scrollPaddingY, (0, _spaceMixin.spaceMixin)(scrollOffset));
  })(props);
});

/** @class CarouselScrollContainerMixin */
/** @method */
var CarouselScrollContainerMixin = function CarouselScrollContainerMixin(props) {
  return (0, _styledToken.default)('CarouselScrollContainer.margin', function (margin) {
    if (margin === void 0) {
      margin = 0;
    }
    return (0, _styledComponents.css)(["list-style:none;margin:", "px;flex-wrap:nowrap;overflow-x:auto;::-webkit-scrollbar{display:none;}scrollbar-width:none;", " ", " ", ""], margin, enableSnapCSS(props), scrollOffsetCSS(props), (0, _focusMixin.focusMixin)(props));
  })(props);
};
exports.CarouselScrollContainerMixin = CarouselScrollContainerMixin;